import React from "react";
import close from "../../../assets/images/model/close.svg";
import butterfly from "../../../assets/images/model/butterflyVideo.svg";
const UploadedVideo = ({ setUploadedVideo, setUploadingVideo }) => {
  return (
    <div>
      <div
        className="modal custom_background custom_modal_create"
        id="upload_book"
        style={{ display: "block" }}
        tabIndex="-1"
        aria-labelledby="upload_bookLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <button
                onClick={() => {
                  setUploadingVideo(false);
                  setUploadedVideo(false);
                }}
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <img src={close} alt="close" />
              </button>
            </div>
            <div className="modal-body-cre">
              <h4>add video</h4>
              <div className="add_img_cre">
                <img src={butterfly} alt="Image of butterfly" />
                <form action="" className="pick_from_library">
                  <div className="pick_from_library_filter_wrap">
                    <div className="pick_from_library_filter my-40 mt-20">
                      <div className="icon">
                        <div className="tooltip_wrap">
                          <h2 className="icon_h2">Video source </h2>
                        </div>

                        <input
                          style={{ height: "60px" }}
                          type="text"
                          value="https://www.youtube.com/watch?v=1b87rwtXGzA"
                          className="pick_from_input_cre border_color url_bg"
                          // placeholder="Paste the link..."
                        />
                      </div>
                    </div>
                  </div>
                  <div className="modal-btn">
                    <button
                      type="button"
                      className="btn-black_create "
                      onClick={() => {
                        setUploadingVideo(false);
                        setUploadedVideo(false);
                      }}
                    >
                      Done
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UploadedVideo;
